import { getMapCorner, inBounds, normalizeLongitude } from "./geo";
import { settings, showDistanceFromCenter, storeLocatorMap } from "..";

// return locations only in current map viewport
export function filterByCurrentMapView(points) {
    if (storeLocatorMap.getZoom() < 3) return points;
    let ne = getMapCorner("ne");
    let sw = getMapCorner("sw");
    ne.lng = normalizeLongitude(ne.lng);
    sw.lng = normalizeLongitude(sw.lng);
    return points.filter(point => inBounds({ lat: point.lat, lng: point.lon }, ne, sw));
}

// filter locations by searching phrase and tags
export function filterLocationsBySearchingPhrase(locations, searchingPhrase) {
    var result = [];
    if (searchingPhrase !== "") {
        for (let location of locations) {
            if (
                (location.name
                    ? !location.name.toLowerCase().replace(/\s/g, '').includes(searchingPhrase.toLowerCase().replace(/\s/g, ''))
                    : true) &&
                (location.city
                    ? !location.city.toLowerCase().replace(/\s/g, '').includes(searchingPhrase.toLowerCase().replace(/\s/g, ''))
                    : true) &&
                (location.country
                    ? !location.country
                        .toLowerCase()
                        .startsWith(searchingPhrase.toLowerCase())
                    : true) &&
                (location.province
                    ? !location.province
                        .toLowerCase()
                        .startsWith(searchingPhrase.toLowerCase())
                    : true) &&
                (location.zipCode
                    ? !location.zipCode
                        .toLowerCase()
                        .startsWith(searchingPhrase.toLowerCase())
                    : true) &&
                (location.address
                    ? !location.address
                        .toLowerCase()
                        .includes(searchingPhrase.toLowerCase())
                    : true)
            ) {
                continue;
            } else {
                result.push(location);
            }
        }
        return result;
    } else {
        return locations;
    }
}

export function sortLocations(locations) {
    if (showDistanceFromCenter) {
        return locations.sort((a, b) => a.d - b.d);
    } else {
        switch (settings.sortMethod) {
            case 0:
                // name A to Z
                return locations.sort((a, b) => a.name.localeCompare(b.name));
            case 1:
                // custom order
                if (settings.positions?.length) {
                    let sortedLocations = [];
                    settings.positions.forEach(el => {
                        let element = locations.find(location => location.storeId ? (location.storeId) == el : (location.id == el));
                        if (element) {
                            sortedLocations.push(element);
                        }
                    });
                    return sortedLocations;
                }
            case 2:
                // by priority (from lowest to highest)
                return locations.sort((a, b) => a.priority - b.priority);
            case 3:
                // by priority (from highest to lowest)
                return locations.sort((a, b) => b.priority - a.priority);
            case 5:
                // by added date (from newest to oldest)
                return locations.sort((a, b) => b.id - a.id);
            case 6:
                // by added date (from oldest to newest)
                return locations.sort((a, b) => a.id - b.id);
            case 4:
                // name Z to A
                return locations.sort((a, b) => -1 * a.name.localeCompare(b.name));
        }
        return locations.sort((a, b) => a.name.localeCompare(b.name));
    }
}